import { render, staticRenderFns } from "./add-edit.vue?vue&type=template&id=5b773d40&scoped=true&"
import script from "./add-edit.vue?vue&type=script&lang=ts&"
export * from "./add-edit.vue?vue&type=script&lang=ts&"
import style0 from "./add-edit.vue?vue&type=style&index=0&id=5b773d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b773d40",
  null
  
)

export default component.exports